import React from 'react';
import { useLocation } from 'react-router-dom';
import useUnitLinks from '../hooks/useUnitLinks';
import { Awa300x600Content } from './components/Awa300x600Content';
import { Awa728x90Content } from './components/Awa728x90Content';
import { BannerContentMiddle } from './components/BannerContentMiddle';
import { BannerContentTop } from './components/BannerContentTop';
import { BottomNewsContent } from './components/BottomNewsContent';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { InAdContent } from './components/InAdContent';
import { TopNewsContent } from './components/TopNewsContent';
import './index.scss';

export const Runup = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const unitLinks = useUnitLinks({ searchParams });

    return (
        <div className='module-2'>
            <Header />
            <TopNewsContent />
            <BannerContentTop />
            <InAdContent src={unitLinks.inAd} />
            <BannerContentMiddle />
            <Awa300x600Content src={unitLinks['300x600']} />
            <Awa728x90Content src={unitLinks['728x90']} />
            <BottomNewsContent />
            <Footer />
        </div>
    );
};
